/**
 * Formats a 10-digit phone number to the standard format: +1 (XXX) XXX-XXXX
 * @param {string} phoneNumber - 10 digit phone number without formatting
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || phoneNumber.length !== 10) {
    return phoneNumber;
  }
  return `+1 (${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
};
